import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ConferenceService } from '@core/services/conference/conference.service';

@Injectable({
  providedIn: 'root',
})
export class ConferenceAccessGuard implements CanActivateChild {
  constructor(
    private readonly conferenceService: ConferenceService,
    private readonly router: Router
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    const conferenceUuid = route.paramMap.get('uuid');

    if (!conferenceUuid) {
      this.router.navigate(['/live']);
      return of(false);
    }

    return this.conferenceService.getConference(conferenceUuid).pipe(
      map((conference) => {
        if (!conference.expiration_date) return true;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const expiryDate = new Date(conference.expiration_date);
        expiryDate.setHours(0, 0, 0, 0);

        const isExpired = today > expiryDate;

        if (isExpired) {
          this.router.navigate(['/live']);
          return false;
        }

        return true;
      }),
      catchError(() => {
        this.router.navigate(['/live']);
        return of(false);
      })
    );
  }
}
